import { render, staticRenderFns } from "./TestimonialItem.vue?vue&type=template&id=11bc2e46&scoped=true&"
import script from "./TestimonialItem.vue?vue&type=script&lang=ts&"
export * from "./TestimonialItem.vue?vue&type=script&lang=ts&"
import style0 from "./TestimonialItem.vue?vue&type=style&index=0&id=11bc2e46&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11bc2e46",
  null
  
)

export default component.exports